/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssignPlanToUser,
  AssignableTrainingPlan,
  CreateTrainingPlan,
  TrainingPlan,
  UpdatePlanAndNotifyDTO,
} from '../models/index';
import {
    AssignPlanToUserFromJSON,
    AssignPlanToUserToJSON,
    AssignableTrainingPlanFromJSON,
    AssignableTrainingPlanToJSON,
    CreateTrainingPlanFromJSON,
    CreateTrainingPlanToJSON,
    TrainingPlanFromJSON,
    TrainingPlanToJSON,
    UpdatePlanAndNotifyDTOFromJSON,
    UpdatePlanAndNotifyDTOToJSON,
} from '../models/index';

export interface PlanAssignPlanRequest {
    assignPlanToUser: AssignPlanToUser;
}

export interface PlanByIdRequest {
    planId: string;
}

export interface PlanCreatePlanRequest {
    createTrainingPlan: CreateTrainingPlan;
}

export interface PlanDeletePlanRequest {
    planId: string;
}

export interface PlanGetAssignablePlansForUserRequest {
    userId: string;
}

export interface PlanUnAssignPlanRequest {
    assignPlanToUser: AssignPlanToUser;
}

export interface PlanUpdatePlanRequest {
    trainingPlan: TrainingPlan;
}

export interface PlanUpdatePlanWithEmailRequest {
    updatePlanAndNotifyDTO: UpdatePlanAndNotifyDTO;
}

/**
 * 
 */
export class PlanApi extends runtime.BaseAPI {

    /**
     */
    async planAssignPlanRaw(requestParameters: PlanAssignPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignPlanToUser'] == null) {
            throw new runtime.RequiredError(
                'assignPlanToUser',
                'Required parameter "assignPlanToUser" was null or undefined when calling planAssignPlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plan/assign-plan/{planId}`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignPlanToUserToJSON(requestParameters['assignPlanToUser']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async planAssignPlan(requestParameters: PlanAssignPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planAssignPlanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async planByIdRaw(requestParameters: PlanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TrainingPlan>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/plan/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TrainingPlanFromJSON(jsonValue));
    }

    /**
     */
    async planById(requestParameters: PlanByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TrainingPlan> {
        const response = await this.planByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planCreatePlanRaw(requestParameters: PlanCreatePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['createTrainingPlan'] == null) {
            throw new runtime.RequiredError(
                'createTrainingPlan',
                'Required parameter "createTrainingPlan" was null or undefined when calling planCreatePlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTrainingPlanToJSON(requestParameters['createTrainingPlan']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async planCreatePlan(requestParameters: PlanCreatePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planCreatePlanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async planDeletePlanRaw(requestParameters: PlanDeletePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['planId'] == null) {
            throw new runtime.RequiredError(
                'planId',
                'Required parameter "planId" was null or undefined when calling planDeletePlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/plan/{planId}`.replace(`{${"planId"}}`, encodeURIComponent(String(requestParameters['planId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async planDeletePlan(requestParameters: PlanDeletePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planDeletePlanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async planGetAssignablePlansForUserRaw(requestParameters: PlanGetAssignablePlansForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssignableTrainingPlan>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling planGetAssignablePlansForUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/plan/assignable/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssignableTrainingPlanFromJSON));
    }

    /**
     */
    async planGetAssignablePlansForUser(requestParameters: PlanGetAssignablePlansForUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssignableTrainingPlan>> {
        const response = await this.planGetAssignablePlansForUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async planListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TrainingPlan>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrainingPlanFromJSON));
    }

    /**
     */
    async planList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TrainingPlan>> {
        const response = await this.planListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async planUnAssignPlanRaw(requestParameters: PlanUnAssignPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assignPlanToUser'] == null) {
            throw new runtime.RequiredError(
                'assignPlanToUser',
                'Required parameter "assignPlanToUser" was null or undefined when calling planUnAssignPlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plan/unassign-plan/{planId}`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignPlanToUserToJSON(requestParameters['assignPlanToUser']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async planUnAssignPlan(requestParameters: PlanUnAssignPlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planUnAssignPlanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async planUpdatePlanRaw(requestParameters: PlanUpdatePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['trainingPlan'] == null) {
            throw new runtime.RequiredError(
                'trainingPlan',
                'Required parameter "trainingPlan" was null or undefined when calling planUpdatePlan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plan`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TrainingPlanToJSON(requestParameters['trainingPlan']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async planUpdatePlan(requestParameters: PlanUpdatePlanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planUpdatePlanRaw(requestParameters, initOverrides);
    }

    /**
     */
    async planUpdatePlanWithEmailRaw(requestParameters: PlanUpdatePlanWithEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updatePlanAndNotifyDTO'] == null) {
            throw new runtime.RequiredError(
                'updatePlanAndNotifyDTO',
                'Required parameter "updatePlanAndNotifyDTO" was null or undefined when calling planUpdatePlanWithEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/plan/update-plan-and-notify-users`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePlanAndNotifyDTOToJSON(requestParameters['updatePlanAndNotifyDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async planUpdatePlanWithEmail(requestParameters: PlanUpdatePlanWithEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.planUpdatePlanWithEmailRaw(requestParameters, initOverrides);
    }

}
